import React from 'react';
import './TagList.css';

const TagList = ({ 
  selectedTags, 
  setSelectedTags, 
  isPanelOpen, 
  setIsPanelOpen,
  availableTags = []
}) => {
  const handleTagClick = (tag, e) => {
    e.stopPropagation();
    if (!selectedTags.includes(tag) && selectedTags.length < 1) {
      setSelectedTags(prev => [...prev, tag]);
    } else {
      setSelectedTags(prev => prev.filter(t => t !== tag));
    }
  };

  const handleRemoveTag = (tag, e) => {
    e.stopPropagation();
    setSelectedTags(prev => prev.filter(t => t !== tag));
  };

  const openPanel = (e) => {
    e.preventDefault();
    setIsPanelOpen(true);
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.classList.contains('full-panel-overlay')) {
        event.preventDefault();
        event.stopPropagation();
        setIsPanelOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsPanelOpen(false);
      }
    };

    if (isPanelOpen) {
      document.addEventListener('click', handleClickOutside, true);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isPanelOpen, setIsPanelOpen]);

  return (
    <div 
      className="selected-tags-container" 
      onClick={openPanel}
    >
      <div className="selected-tags-list">
        {selectedTags.length > 0 ? (
          selectedTags.map((tag) => (
            <span key={tag} className="selected-tag">
              {tag}
              <button
                onClick={(e) => handleRemoveTag(tag, e)}
                className="remove-tag"
              >
                ×
              </button>
            </span>
          ))
        ) : (
          <span className="placeholder-text">Click to add style tags</span>
        )}
      </div>

      {isPanelOpen && (
        <div className="full-panel-overlay">
          <div className="tag-selection-panel">
            <h3>Select Style Tags</h3>
            <div className="available-tags">
              {availableTags.map((tag) => (
                <button
                  key={tag}
                  className={`tag-option ${selectedTags.includes(tag) ? 'selected' : ''}`}
                  onClick={(e) => handleTagClick(tag, e)}
                  disabled={selectedTags.length >= 1 && !selectedTags.includes(tag)}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TagList; 